export var EOmniChannelActionEnum;
(function (EOmniChannelActionEnum) {
    EOmniChannelActionEnum["CHANNEL_REGISTRATION_APPLICATION"] = "CHANNEL_REGISTRATION_APPLICATION";
    EOmniChannelActionEnum["CHANNEL_REGISTRATION_ACCEPTED"] = "CHANNEL_REGISTRATION_ACCEPTED";
    EOmniChannelActionEnum["CHANNEL_REGISTRATION_REJECTED"] = "CHANNEL_REGISTRATION_REJECTED";
})(EOmniChannelActionEnum || (EOmniChannelActionEnum = {}));
